import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { AlertCircle } from "lucide-react";

export default function WhyItFailedPanel({ explanation, score }) {
  return (
    <Card className="why-failed-panel border-red-200" data-testid="why-failed-panel">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg font-bold flex items-center gap-2 text-red-900">
            <AlertCircle className="w-5 h-5" />
            Why This Failed
          </CardTitle>
          {score !== undefined && (
            <Badge variant="destructive" className="font-mono">
              Score: {score}/100
            </Badge>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-sm font-mono text-red-800 leading-relaxed">
          {explanation}
        </p>
      </CardContent>
    </Card>
  );
}
